export interface RithmicTickersModel {
    symbol: string
    last_price: number
}

export interface RithmicAccountModel {
    balance: string
}

export interface RithmicPositionsModel {
    symbol: string
    price: number
    pnl: string
    quantity: number
}

export enum RithmicTransactionTypes {
    BUY = 1,
    SELL,
}

export enum RithmicPriceTypes {
    LIMIT = 1,
    MARKET,
}

export enum RithmicManualOrAutoTypes {
    MANUAL = 1,
    AUTO,
}

export enum RithmicExchangeNotifyTypes {
    CANCEL = 3,
    FILL = 5,
}

export interface RithmicOrdersResponseModel {
    basket_id: string
    symbol: string
    price: number
    total_fill_size: number
    price_type: RithmicPriceTypes
    transaction_type: RithmicTransactionTypes
    notify_type: number
    quantity: number
    time: number
    text: string
    manual_or_auto?: RithmicManualOrAutoTypes
}
